import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Garantir que o elemento root existe
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Limpar qualquer conteúdo anterior
rootElement.innerHTML = '';

// Criar root e renderizar
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)
